import { Modal } from '../Modal'
import React, { useEffect, useMemo, useRef, useState } from 'react'
import cl from 'classnames'
import titleStyles from '../NominationHeader.module.scss'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { Button, Label, Select } from '@/ui'
import { nominationThunks, NOMINATION_EMPL_FIELDS } from '@/entity/nomination'
import { LoaderWrapper, LoadingBlocker } from '@/components/Loader'
import { CreateForm } from '@features/nomination/Employer/CreateForm'
import { CommonFields } from '@features/nomination/Employer/CommonFields'
import { Divider } from '@/components/Divider/Divider'
import { DigitalSign } from '@/utils/digitalSign'
import { connect, FieldArray, Field as FormikField, Formik, Form } from 'formik'
import { Field } from '@/ui'
import { getCurrentLanguage } from '@/i18next'
import { CreateModalSchema } from '@features/nomination/Employer/Schema'
import { message } from 'antd'
import { isEmpty } from 'lodash'
import styles from './Modal.module.scss'

export const CreateModal = ({ onClose, item, onSuccess }) => {
	const { t } = useTranslation()
	const dispatch = useDispatch()
	const lang = getCurrentLanguage()
	const formRef = useRef(null)

	const digitalSign = new DigitalSign()

	const { dictNomination, dictParams, activeCompany, emplXml } = useSelector((state) => ({
		dictNomination: state.nomination.dictNomination,
		dictParams: state.nomination.dictParams,
		activeCompany: state.company.company,
		emplXml: state.nomination.emplXml,
	}))

	useEffect(() => {
		if (!dictNomination?.success) dispatch(nominationThunks.getDictNomination())
	}, [])

	const handleChangeNomination = (value) => {
		let body = {
			data: { nominationCode: value },
			onSuccess: (res) => {
				formRef.current.setValues({
					nominationCode: value,
					orgName: activeCompany?.companyName || '',
					katoAB: activeCompany?.ddistrictCode || '',
					bin: activeCompany?.bin || '',
					okedCode: activeCompany?.dokedCode || '',
					email: activeCompany?.email || '',
					mobilePhone: activeCompany?.mobilePhone || '',
					workPhone: activeCompany?.officePhone || '',
					categoryCode: '',
					paramValues: res?.sort((a, b) => a.index > b.index ? 1 : -1)?.map(i => {
						if(i.localParamType){
							return {
								paramCode: i.code,
								[i.localParamType]: null
							}
						} else {
							return  null
						}
					}),
				})
			},
		}

		dispatch(nominationThunks.getDictParams(body))
	}

	const handleSubmit = (values) => {
		let body = {
			data: {
				...values,
				katoAB: values.katoAB.substring(0, 2),
				paramValues: values?.paramValues?.filter(i => i),
			},
			onSuccess: async ({ xmlData }) => {
				const res = await digitalSign.handleSend(xmlData)
				let signedBody = {
					data: { xmlData: res },
					onSuccess: (res) => {
						onClose()
						message.success(t('success_alert'))
						onSuccess()
					},
				}

				dispatch(nominationThunks.setEmplSign(signedBody))
			},
			onError: () => {
				onClose()
			},
		}

		dispatch(nominationThunks.setEmplXml(body))
	}

	return (
		<Modal onClose={onClose}>
			<h3 className={cl(titleStyles.titlebig)}>{t('nomination.create.title')}</h3>

			<Formik
				onSubmit={handleSubmit}
				initialValues={{}}
				validationSchema={CreateModalSchema}
				innerRef={formRef}
			>
				{({ values, errors }) => {
					return (
						<Form>
							<div className={cl('mt-4', 'mb-4', {[styles.select]: !values.nominationCode})}>
								<LoaderWrapper isLoading={dictNomination.loading}>
									<FormikField name={NOMINATION_EMPL_FIELDS.nominationCode}>
										{({ field, meta: { touched, error } }) => (
											<Field
												{...field}
												isRequired
												type="text"
												fieldType="select"
												label={t('nomination.nomination')}
												options={dictNomination.data || []}
												error={touched && error}
												onChange={(value) => {
													field.onChange(value)
													handleChangeNomination(value)
												}}
											/>
										)}
									</FormikField>
								</LoaderWrapper>
							</div>

							{
								values.nominationCode &&
								<div>
									<CommonFields />

									<Divider />

									<div className={cl('py-4')}>
										<CreateForm />
									</div>
								</div>
							}

							<div className={cl('flex', 'justify-content-end')}>
								<Button type="submit" disabled={!isEmpty(errors)}>
									{t('sign_ecp')}
								</Button>
							</div>
						</Form>
					)
				}}
			</Formik>

			{(dictParams.loading || emplXml.loading) && <LoadingBlocker />}
		</Modal>
	)
}